module.exports = __webpack_public_path__ + "img/icon-white-matchpreview.1d4924a5.svg";